import React from "react";
import "./index.scss";
import { Carousel, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { DownCircleOutlined, UpCircleOutlined } from "@ant-design/icons";
import ceremonyDefault from "../../assets/images/HomePage/ceremony_default.svg";

const { Paragraph } = Typography;

const Information = ({ product }) => {
  const { t } = useTranslation();
  const ceremonyImage = product?.ceremony_image?.split(",");
  const myRef = React.useRef(null);
  const [displayNone, setDisplayNone] = React.useState("d-none")

  React.useEffect(() => {
    if (
      (product?.ceremony_image || product?.ceremony_desc) &&
      window.location.href.indexOf("ceremony") !== -1
    ) {
      myRef.current.scrollIntoView();
    }
  }, [product]);
  
  return (
    <>
      <Typography className="page-information">
        <div className="page-information-title">
          <h2 className="page-information-title-text">{t("product.info")}</h2>
          <span
            onClick={() =>
              displayNone === "" ? setDisplayNone("d-none") : setDisplayNone("")
            }>
            {displayNone === "" ? <UpCircleOutlined /> : <DownCircleOutlined />}
          </span>
        </div>
        <Paragraph className={`paragraph-block ${displayNone}`}>
          <h3 className="product-title">
            {product?.product_name}
            <br />
            <br />
            Código: {product?.product_code}
          </h3>
          <div className="product-desc">{product?.description?.trim()}</div>
        </Paragraph>
      </Typography>
      {product?.ceremony_image || product?.ceremony_desc ? (
        <Typography className="page-information">
          <a
            ref={myRef}
            href="#ceremony"
            id="ceremony"
            className="ceremony-title">
            {t("product.ceremony")}
          </a>
          {ceremonyImage ? (
            <Carousel autoplay>
              {ceremonyImage?.map((image) => {
                return (
                  <div>
                    <img
                      className="ceremony-image"
                      src={image}
                      alt="winner ceremony"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = ceremonyDefault;
                      }}
                    />
                  </div>
                );
              })}
            </Carousel>
          ) : null}
          <Paragraph className="paragraph-block">
            {product?.ceremony_desc}
          </Paragraph>
        </Typography>
      ) : null}
    </>
  );
};

export default Information;
